/**
 * "Your expense claims awaiting approval: N" on the Me home and the list it
 * opens must agree (persona round 2026-10, Sneha: the home said 1, the
 * link opened "My claims" with every status, so the employee counted
 * drafts / approved / reimbursed claims too and the numbers didn't match).
 *
 * One definition drives both: the count reads GET /expenses with these
 * params, and the row links to the My expenses list pre-filtered to the
 * same status. The list reads the filter from the URL (?status=) through
 * parseExpenseListStatus.
 */

/** Claims the employee has sent and nobody has decided yet. */
export const AWAITING_APPROVAL_STATUS = "submitted";

/** GET /expenses params for the Me-home count (own claims only). */
export const MY_AWAITING_EXPENSES_QUERY = {
  status: AWAITING_APPROVAL_STATUS,
  mine: true,
} as const;

/** Search params of the Me-home row's link to the My expenses list. */
export const MY_AWAITING_EXPENSES_LINK_SEARCH = {
  status: AWAITING_APPROVAL_STATUS,
} as const;

export const EXPENSE_LIST_STATUSES = [
  "all",
  "draft",
  "submitted",
  "approved",
  "rejected",
  "reimbursed",
] as const;

export type ExpenseListStatus = (typeof EXPENSE_LIST_STATUSES)[number];

/** The list's status filter from the URL; anything unknown → undefined. */
export function parseExpenseListStatus(raw: unknown): ExpenseListStatus | undefined {
  return typeof raw === "string" &&
    (EXPENSE_LIST_STATUSES as readonly string[]).includes(raw)
    ? (raw as ExpenseListStatus)
    : undefined;
}

/** validateSearch for the My expenses route. */
export function expensesSearchSchema(search: Record<string, unknown>): {
  status?: ExpenseListStatus;
} {
  const status = parseExpenseListStatus(search.status);
  return status ? { status } : {};
}

/** The rows the list shows under a status filter (mirrors the server). */
export function rowsForStatus<T extends { status: string }>(
  rows: readonly T[],
  status: ExpenseListStatus,
): T[] {
  return status === "all" ? [...rows] : rows.filter((r) => r.status === status);
}
